module.exports = {"id":"149185","name":"Francesco Magnanelli","rating":"75","photo":"./data/images/photos/1/149185.png","club":{"name":"Sassuolo","logo":"./data/images/clubs/Sassuolo.png"},"positions":["MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FrancescoMagnanelli0.json
// module id = 1467
// module chunks = 0